import React, { Component } from 'react';
import './Body.css';

import Field from '../Field/Field'
import Widget from '../Widget/Widget'

class Body extends Component {
  renderFieldType(field, idx, id) {
    switch (field.type) {
      case 'widget':
        return <Widget id={id} key={idx} field={field}/>
      default:
        return <Field key={idx} field={field} />
    }
  }

  render() {
    const { data } = this.props
    const { screenflow, screens, fields } = data

    return (
      screenflow.map((element, idx) => {
        let className = `${element.fullScreen ? 'screen-fullscreen screen' : 'screen'}`
        className = `${className} ${element.fullBackground ? 'full-screen-bg' : ''}`
        className = `${className} ${element.irregularYellowBackground ? 'irregular-bg-yellow' : ''}`
        className = `${className} ${element.irregularGreenBackground ? 'irregular-bg-green' : ''}`
        className = `${className} ${element.irregularBlueBackground ? 'irregular-bg-blue' : ''}`
        return (
          <div key={idx} className={className}>
            <div className='screen-content'>
              {screens[element.id].fields.map((element, idx) => {
                const field = fields[element.id]
                return this.renderFieldType(field, idx, element.id)
              })}
            </div>
          </div>
        )
      })
    );
  }
}

export default Body;
